import {Component} from 'Common/components/Component';
import {OverlayComponent as ShowConfig} from 'Common/config/PageConfigTypes';

export class OverlayComponent extends Component
{
	constructor(
		instanceName:string,
		private config:ShowConfig,
		private localData:{[pane:string]:boolean} 
	)
	{
		super(instanceName);
		this.toggle = this.toggle.bind(this);
	}

    public componentType():string { return 'overlay'; }

	async load()
	{
		return {...this.config.panes};
	}

	public toggle(fieldName:string)
	{
console.log('OverlayComponent toggle()  fieldName:',fieldName);		

		this.localData[fieldName] = ! this.localData[fieldName];
	}


//XXX THINK UNUSED. Dont sem to use the overlayed class any more	
	public htmlClasses():Set<string> 
	{ 
		const classes:Set<string> = new Set();

		for (const item of Object.values(this.localData)) 
			if (item) {
				classes.add('overlayed');
				break;
			}

		return classes;
	} 
}
